import { Loading } from "@mozioinc/ui";
import { ErrorBoundary } from "@sentry/react";
import { Router } from "@tanstack/react-router";
import { GeneralError } from "../components";
import { queryClient } from "../utils/query-client";
import { notFoundRoute } from "./404";
import { bookingRoute } from "./booking";
import { confirmationRoute } from "./confirmation";
import { homeRoute } from "./home";
import { manageReservationRoute } from "./manage-reservation";
import { rootRoute } from "./root";
import { searchRoute } from "./search-result";
import { termsAndConditionsRoute } from "./terms-and-conditions";
import { whiteLabelRoute } from "./white-label";

const routeTree = rootRoute.addChildren([
  homeRoute,
  searchRoute,
  bookingRoute,
  confirmationRoute,
  termsAndConditionsRoute,
  manageReservationRoute,
  whiteLabelRoute,
]);

export const router = new Router({
  routeTree,
  defaultPendingComponent: () => <Loading className="h-screen" />,
  defaultErrorComponent: () => (
    <ErrorBoundary>
      <GeneralError className="h-screen" />
    </ErrorBoundary>
  ),
  context: {
    queryClient,
  },
  defaultPreload: "intent",
  // Since we're using React Query, we don't want loader calls to ever be stale
  // This will ensure that the loader is always called when the route is preloaded or visited
  defaultPreloadStaleTime: 0,
  basepath: "/parking",
  notFoundRoute,
});

declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}
